import React from "react";
import "./styles.scss";

function LoadingDots({ spinnerClass }) {
  return (
    <div className="spinner">
      <div className={`bounce1 ${spinnerClass}`} />
      <div className={`bounce2 ${spinnerClass}`} />
      <div className={`bounce3 ${spinnerClass}`} />
    </div>
  );
}

export default LoadingDots;



// WEBPACK FOOTER //
// ./resources/assets/js/app/LoadingDots/LoadingDots.js